import { Component } from '@rhtml/component';
import { AngularLayout } from '@rhtml/modifiers';
import { deepCopy } from '@rxdi/graphql-client';
import { html, LitElement, property, unsafeCSS } from '@rxdi/lit-html';
import { Router } from '@rxdi/router';
import { SteelFabTheme } from '@shared/styles/theme';
import * as MobileNavigationComponentCSS from 'bundle-text:./mobile-navigation.component.css';
import { map, startWith } from 'rxjs/operators';

/**
 * @customElement mobile-navigation-component
 */
@Component({
  Settings: {
    selector: 'mobile-navigation-component',
    styles: [SteelFabTheme, unsafeCSS(MobileNavigationComponentCSS)],
    modifiers: [...AngularLayout],
  },
  State(this: MobileNavigationComponent) {
    return this.router.onSnapshotChange().pipe(
      map((path) => ({
        currentPath: path.detail.location.pathname,
        isDrawerOpen: false,
      })),
      startWith({ isDrawerOpen: false, currentPath: location.pathname })
    );
  },
  Render: () =>
    function (this: MobileNavigationComponent, state, setState) {
      const { isDrawerOpen, currentPath } = deepCopy(state);

      return html`
        <sl-drawer
          class="drawer"
          label="Категории продукти"
          placement="start"
          .open=${isDrawerOpen}
          @sl-after-hide=${() => {
            setState({ ...state, isDrawerOpen: false });
          }}
        >
          <div slot="label" class="drawer-title"><sl-icon name="list"></sl-icon> Категории</div>

          <div class="sidebar-wrapper">
            <!-- Ensure products-sidebar-component opens its tree structure and gets current route info -->
            <products-sidebar-component
              .shouldFetchCategory=${false}
              .shouldOpenTreeStructureOnClick=${false}
              .routeParams=${this.routeParams}
            ></products-sidebar-component>
          </div>
        </sl-drawer>

        <nav class="bottom-nav">
          <button
            class="nav-item ${currentPath === '/' ? 'active' : ''}"
            @click=${() => this.goto('/')([state, setState])}
          >
            <sl-icon class="nav-icon" name="house-door" library="default"></sl-icon>
            <span class="nav-label">Начало</span>
          </button>

          <button
            class="nav-item ${currentPath.includes('/products') || isDrawerOpen ? 'active' : ''}"
            @click=${() => {
              state.isDrawerOpen = !state.isDrawerOpen;
              setState({ ...state });
            }}
          >
            <sl-icon class="nav-icon" name="grid" library="default"></sl-icon>
            <span class="nav-label">Продукти</span>
          </button>

          <button
            ngIf=${false}
            class="nav-item ${currentPath.includes('/about') ? 'active' : ''}"
            @click=${() => {
              this.goto('/about')([state, setState]);
            }}
          >
            <sl-icon class="nav-icon" name="info-circle" library="default"></sl-icon>
            <span class="nav-label">За нас</span>
          </button>

          <button
            ngIf=${false}
            class="nav-item ${currentPath.includes('/blog') ? 'active' : ''}"
            @click=${() => this.goto('/blog')([state, setState])}
          >
            <sl-icon class="nav-icon" name="journal-richtext" library="default"></sl-icon>
            <span class="nav-label">Блог</span>
          </button>
        </nav>
      `;
    },
})
export class MobileNavigationComponent extends LitElement {
  @Router()
  router: Router;

  @property({ type: Object })
  routeParams: { group?: string; brand?: string; subtype?: string; slug?: string };

  @property({ type: String })
  currentPath = location.pathname;

  goto(path: string) {
    return ([state, setState]) => {
      this.router.go(path);
      if (state.isDrawerOpen) {
        state.isDrawerOpen = false;
      }
      setState({ ...state });
    };
  }
}
